import { useDraggable } from "@dnd-kit/core";
import type React from "react";
import type { DragData } from "../types";

interface DndProps {
  children: React.ReactNode;
  id: string;
  data: DragData;
  className?: string;
}

export function Dnd({ children, id, data, className }: DndProps) {
  const { attributes, listeners, setNodeRef, transform, isDragging } = useDraggable({ id, data });

  const style: React.CSSProperties = {
    transform: transform ? `translate3d(${transform.x}px, ${transform.y}px, 0)` : undefined,
    opacity: isDragging ? 0.8 : 1,
  };

  return (
    <div ref={setNodeRef} {...listeners} {...attributes} style={style} className={className}>
      {children}
    </div>
  );
}
